import React from "react";
import Satu from "./satu.svg";
import Dua from "./dua.svg";
import Tiga from "./tiga.svg";
import Eva from "./Eva.svg";
// import Icon1 from '../assets/satu.svg';
// import Icon2 from '../assets/dua.svg';
// import Icon3 from '../assets/tiga.svg';
// import Icon4 from "../assets/empat.svg";

import Logoapp from "../assets/LogoApp.svg";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
// import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles((theme) => ({

//   root: {
//     width: '100%',
//   },
//   heading: {
//     backgroundColor: '#0b6d3c',
//   },
//   classFont :{
//     color: 'white',
//     width: `${(props) => (props.clicked ? "100%" : "0")}`,
//   overflow: 'hidden',
//   marginLeft: `${(props) => (props.clicked ? "1.5rem" : "0")}`,
//   transition: 'all 0.3s ease',
//   fontFamily: 'Poppins'
//   },
//   iconColor: {
//     color: 'white'
//   },
//   fullheight:
//   {
//     height:'100vh'
//   },

// }));

const Container = styled.div`
	position: fixed;
	.active {
		border-right: 4px solid var(--white);
		img {
			filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
				brightness(103%) contrast(103%);
		}
	}
	z-index: 100;
`;
const Button = styled.button`
	background-color: var(--green);
	border: none;
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 50%;
	margin: 0.5rem 0 0 0.5rem;
	cursor: pointer;

	display: flex;
	justify-content: center;
	align-items: center;

	position: relative;

	&::before,
	&::after {
		content: "";
		background-color: var(--white);
		height: 2px;
		width: 1rem;
		position: absolute;
		transition: all 0.3s ease;
	}

	&::before {
		top: ${(props) => (props.clicked ? "1.5" : "1rem")};
		transform: ${(props) => (props.clicked ? "rotate(135deg)" : "rotate(0)")};
	}
	&::after {
		top: ${(props) => (props.clicked ? "1.2" : "1.5rem")};
		transform: ${(props) => (props.clicked ? "rotate(-135deg)" : "rotate(0)")};
	}
`;

const SidebarContainer = styled.div`
	background-color: #206040;
	// background-color: var(--green);
	width: 3.5rem;
	min-height: 100vh;
	margin-top: 0.5rem;
	border-radius: 0 30px 30px 0;
	padding: 1rem 0;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;

	position: relative;

	@media (max-width: 425px) {
		width: 0;
	}
`;

const SlickBar = styled.ul`
	color: var(--white);
	list-style: none;
	display: ${(props) => (props.clicked ? "flex" : "flex")};
	flex-direction: column;

	align-items: center;
	background-color: #206040;
	height: 100%;
	padding: 2rem 0;
	position: absolute;
	top: 1rem;
	left: 0;

	width: ${(props) => (props.clicked ? "15rem" : "3.5rem")};
	transition: all 0.5s ease;
	border-radius: 0 30px 30px 0;

	@media (max-width: 425px) {
		width: ${(props) => (props.clicked ? "15rem" : "0")};
		height: 80vh;
	}
`;

const Item = styled(NavLink)`
	text-decoration: none;
	color: var(--white);
	width: 100%;
	padding: 1rem 0;
	cursor: pointer;

	display: flex;
	padding-left: 1rem;

	&:hover {
		border-right: 4px solid var(--white);
		color: var(--black);
		img {
			border: none;
			filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
				brightness(103%) contrast(103%);
		}
	}

	img {
		border: none;
		width: 1.2rem;
		height: auto;
		filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg)
			brightness(78%) contrast(85%);

		@media (max-width: 425px) {
			width: ${(props) => (props.clicked ? "100%  " : "0")};
		}
	}
`;

const Text = styled.span`
	width: ${(props) => (props.clicked ? "100%" : "0")};
	overflow: hidden;
	margin-left: ${(props) => (props.clicked ? "1.5rem" : "0")};
	transition: all 0.3s ease;
`;

const Sidebar = ({ click, handleClick }) => {
	return (
		<Container>
			<Button clicked={click} onClick={() => handleClick()}></Button>
			<SidebarContainer>
				<div>
					<SlickBar clicked={click}>
						<Item
							//  onClick={()=> setClick(false)}
							exact
							activeClassName="active"
							to="/materi"
						>
							<img src={Satu} alt="Icon1" />
							<Text clicked={click}>SPtLDV</Text>
						</Item>

						<Item
							// onClick={()=> setClick(false)}
							activeClassName="active"
							to="/materi/programlinear"
						>
							<img src={Dua} alt="Icon2" />
							<Text clicked={click}>Program Linear</Text>
						</Item>

						<Item
							// onClick={()=> setClick(false)}
							activeClassName="active"
							to="/materi/nilai"
						>
							<img src={Tiga} alt="Icon3" />
							<Text clicked={click}>Nilai Optimum</Text>
						</Item>

						<Item
							// onClick={()=> setClick(false)}
							activeClassName="active"
							to="/materi/evaluasi"
						>
							<img src={Eva} alt="Icon4" />
							<Text clicked={click}>Evaluasi</Text>
						</Item>

						<Item activeClassName="" to="/">
							<Text clicked={click}>
								<img
									style={{ height: "150px", width: "150px" }}
									src={Logoapp}
									alt="logoooo"
								/>{" "}
							</Text>
						</Item>
					</SlickBar>
				</div>
			</SidebarContainer>
		</Container>
	);
};

export default Sidebar;
